import React, { useContext, useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import RevenueTargetScreen from "./targetRevenue";
import { AlertProps } from '../../../utils';
import { Button } from 'qdm-component-library';
import { CommonTable, VerticalList } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'primary_care_admin_binder';
import { AlertContext } from '../../../contexts';
import { HoverNavBar, TopNavBar } from "../../../components/navbars";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  addBtn: {
    float: "right",
    fontSize: "14px",
    fontWeight: 600,
  },
  content: {
    width: "98%",
    height: "calc(100vh - 64px)",
    overflow: "auto",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 56,
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
    },
    marginTop: "70px",
    marginLeft: "30px",
  },
  topNavbar: {},
  sideNavbar: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hovarNavBar: {
    display: "flex",
    position: "relative",
    top: "63px",
  },
  commanTabbar: {
    display: "flex",
    position: "relative",
    top: "70px",
    marginLeft: "80px"
  }
}));
const styles = {
  outlinedButton: {
      borderColor: "#DEDEDE",
      color: "#2A60BC",
      backgroundColor: "#fff",
      borderRadius: 8,
      fontSize: 14,
      fontFamily: "pc_regular !important",
      display: "block",
      whiteSpace:"nowrap",
    },
    outlinedDelButton: {
      borderColor: "#FF4D4A",
      color: "#FF4D4A",
      backgroundColor: "#fff",
      borderRadius: 8,
      fontSize: 14,
      fontFamily: "pc_regular !important",
      display: "block",
      whiteSpace:"nowrap",
    },
    modalHeading: {
      fontSize: 16,
      color: "#2A60BC",
    },
}
const RevenueTargetList = (props) => {
    const classes = useStyles();
    const [editValue, seteditValue] = useState();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    
    const [formError, setformError] = React.useState(false);
    const alert = useContext(AlertContext);

    const [isFormOpen, setisFormOpen] = useState({
        isForm: false,
        isEdit: false,
        isView: false,
      }); 
    const [openAlert,setOpenAlert] = useState({
            open:false,
            index:null
          });

    const [formConnect, setFormConnect] = useState({
            targetcode: '',
            targetfrom: '',
            targetname: '',
            targettill: '',
            targetvalue: '',
          });

          const [perPage, setPerPage] = React.useState(10);
          const [page, setPage] = React.useState(0);
          const [searchname, setSearchname] = React.useState();
          const dispatch = useDispatch();
           
          const listData = useSelector(
              (state) => state?.targetRevenueSlice?.targetRevenueRead?.data
              );

          const [formRows, setFormRows] = useState(
                    []
                );      

          React.useLayoutEffect(() => {
        const readTargetRevenue = async()=>{
                 dispatch(actions.TARGET_REVENUE_READ({
                  searchname: "", 
                  page: page,
                  perPage: perPage 
                }));
              }
        readTargetRevenue();
                }, []);
                const formatToLocalInputDate = (timestamp) => {
                const date = new Date(timestamp * 1000); 
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0"); 
                const day = String(date.getDate()).padStart(2, "0");
                return `${year}-${month}-${day}`; 
        };

          const handleEdit = async (e, row, index) => {            
              const readTargetEdit = await dispatch(actions.TARGET_REVENUE_EDIT(row?._id));
              let editValue = readTargetEdit?.payload?.data[0]
               const headerparamSet = editValue?.headerparam
            const setheaderparamSetarry =[]
            headerparamSet?.map((setData) =>{  
                setheaderparamSetarry.push(                   
                        { 
                            creteria: {ruleName:setData?.creteria?.value ,_id:setData?.creteria?._id},
                            target: setData?.target
                        }                    
                )
            })           
              seteditValue({
                targetcode: editValue?.targetcode,     
                targetname: editValue?.targetname,
                targetfrom: formatToLocalInputDate(editValue?.targetfrom),
                targettill: formatToLocalInputDate(editValue?.targettill),
                targetvalue: editValue?.targetvalue,
                editId: row?._id,
                headerparams: setheaderparamSetarry,
            })    
            
                setisFormOpen({
                    ...isFormOpen,
                    isForm: false,
                    isEdit: true,
                    isView: false,
                  });
          }
              
          const handleView = async(e, row, index) => {
          const readTargetEdit = await dispatch(actions.TARGET_REVENUE_EDIT(row?._id));
              let editValue = readTargetEdit?.payload?.data[0]
              setFormConnect({
                targetcode: editValue?.targetcode,     
                targetname: editValue?.targetname,
                targetfrom: new Date(editValue?.targetfrom* 1000).toLocaleString(),
                targettill: new Date(editValue?.targettill* 1000).toLocaleString(),
                targetvalue: editValue?.targetvalue,
                editId: row?._id,
            })    
            const headerparamSet = editValue?.headerparam
            const setheaderparamSetarry =[]
            headerparamSet?.map((setData) =>{  
                setheaderparamSetarry.push(                   
                        { 
                            creteria: {ruleName:setData?.creteria?.value ,_id:setData?.creteria?._id},
                            target: setData?.target
                        }                    
                )
            })            
              setFormRows(setheaderparamSetarry)
              setisFormOpen({
              ...isFormOpen,
              isView: true,
              isEdit: false,
              isForm: false,
            });
          }

          const handleForm = () => {
            seteditValue([])
            setFormConnect(
              {
                targetcode:'',
                targetname: '',
                targetfrom: '',
                targettill: '',
                targetvalue: '',
              }
            )
            setisFormOpen({
              ...isFormOpen,
              isForm: true,
              isEdit: false,
              isView: false,
            });
          };

         const handleDelete = async (e, row, index) => {
          e.preventDefault();
          if (!row?._id) {
          console.error("Missing _id for delete");
          return;
      }

  try {
    const deletePayload = { _id: row._id };
    const result = await dispatch(actions.TARGET_REVENUE_DELETE(deletePayload));
    
    if (result?.payload?.data?.Code === 201) {
      setformError(true);
      alert?.setSnack({
        open: true,
        severity: AlertProps.severity.success,
        msg: "Deleted Successfully!",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.right,
        tone: true,
      });
      const readTarget =  dispatch(actions.TARGET_REVENUE_READ({
                           searchname: "", 
                           page: page ?? 0,
                           perPage: perPage ?? 10,
                         })) 
    }
  } catch (err) {
    console.error("Delete error:", err);
  }
}; 

          const handleSearch = (searchVal) => {
            if (searchVal?.length > 1) {
                  dispatch(actions.TARGET_REVENUE_READ({
                    searchname: searchVal,
                    page: page,
                    perPage: perPage
                  }));
                } else if (!searchVal) {
                  dispatch(actions.TARGET_REVENUE_READ({
                    searchname: "",
                    page: page,
                    perPage: perPage
                  }));
                }
          }

          const handlePageChange = async (searchname, currentPage, PerPage) => {
            setPage((currentPage - 1) * PerPage);
            setPerPage(PerPage);
            setSearchname(searchname);
            await dispatch(actions.TARGET_REVENUE_READ({searchname:searchname, page: (currentPage - 1) * PerPage , perPage: PerPage }));
          };
  return (
     <div className={classes.root}>
      {/* Your nav bars here */}
      <div className={classes.topNavbar}>
        <TopNavBar />
      </div>
      {/* Your hovar bars here */}

      <div className={classes.hovarNavBar}>
        <HoverNavBar />
      </div>
      <div className={classes.content}>
      {isFormOpen?.isForm || isFormOpen?.isView || isFormOpen?.isEdit ?
         <RevenueTargetScreen
            formConnect={formConnect}
            setFormConnect={setFormConnect}
            editValue={editValue}
            setFormRows={setFormRows}
            formRows={formRows}
            setisFormOpen={setisFormOpen}
            isFormOpen={isFormOpen}
          />:
          <VerticalList
            parent_id={"administrations"}
            addFunc={handleForm}
            id={"targetrevenue"}
            placeholder={"Search Code & Target Name"}
            onSearchChange={handleSearch}
            hideSearchBar={false}
            hideFilter={true}          
            TabList={[
              {
                name: "Target Revenue",
                component: (
                  <CommonTable
                    parent_id={"administrations"}
                    rightAlign={["View", "Action"]}
                    handleEdit={(e, data, index) => {
                      handleEdit(e, data, index);
                    }}

                    handleView={(e, data, index) => {
                      handleView(e,data,index);
                    }}
                    
                    
                    Header={[
                      { label: "S.No", showSort: false, showFilter: false },
                      { label: "Code", showSort: false, showFilter: false },
                      { label: "Target Name", showSort: false, showFilter: false },
                      { label: "Action", showSort: false, showFilter: false },
                      { label: "View", showSort: false, showFilter: false },
                    ]}
                    dataList={listData}
                    tableData={[
                      { type: ["INCRIMENT"], name: "1" },
                      { type: ["TEXT"], name: "targetcode" },
                      { type: ["TEXT"], name: "targetname" },
                      { type: ["EDIT", "DELETE"], name: "", align: "right" },
                      { type: ["VIEW",], name: "", align: "right" },
                    ]}
                    handleDelete={handleDelete}
                    handlepageChange={(currentPage, PerPage) =>
                      handlePageChange("",currentPage, PerPage)
                    }
                    TableCount={RevenueTargetList?.[0]?.TotalCount}
                    incrementCount={formConnect?.page}
                    showPagination={true}
                    rowsPerPageOptions={[
                      { label: "10 Rows", value: 10 },
                      { label: "50 Rows", value: 50 },
                      { label: "100 Rows", value: 100 },
                    ]}
                  />
                ),
              },
            ]}
          />
          }
          </div>
          {openAlert?.open && (
        <Dialog
        fullScreen={fullScreen}
        open={openAlert?.open}
        onClose={()=>setOpenAlert({
          ...openAlert,
          open:false
        })}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle style={styles.modalHeading} id="alert-dialog-title">{"Are you Sure Want to Delete ?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{padding:"15px"}}>
          <Button onClick={()=>setOpenAlert({
            ...openAlert,
            open:false
          })} color="primary"
          style={styles.outlinedButton}
          variant="contained"
          >
            No
          </Button>
          <Button color="primary"
          style={styles.outlinedDelButton}
          variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      )}
    </div>
  )
}

export default RevenueTargetList